import React, { Component } from 'react';
import { ButtonToolbar, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import '../../content/css/CategoryOptionEditControl.css';

export default class CategoryOptionEditControl extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.getDefaultValues()
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.isActive !== this.props.isActive) {
            this.setState({ value: this.getDefaultValues() });
        }
    }

    handleChange = (value) => {
        this.setState({ value });
        if (this.props.isActive !== value.includes(1)) this.props.onChange(value.includes(1));
    }

    getDefaultValues() {
        var values = [];
        if (this.props.isActive) values.push(1);
        return values;
    }

    getActiveHeader() {
        return this.state.value.includes(1) ? "Enabled" : "Disabled";
    }

    render() {
        return (
            <ButtonToolbar>
                <ToggleButtonGroup type="checkbox" value={this.state.value} onChange={this.handleChange}>
                    <ToggleButton className="option-edit-btn" value={1}>{this.getActiveHeader()}</ToggleButton>
                </ToggleButtonGroup>
            </ButtonToolbar>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CategoryView/CategoryOptionEditControl.js